import { SvgProps } from "./types";

export const AngelSmallRight = (props: SvgProps) => (
  <svg
    width="5"
    height="8"
    viewBox="0 0 5 8"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M1.4057 7.35352L0.700195 6.64651L3.3447 4.00001L0.700195 1.35351L1.4077 0.646515L4.0502 3.29302C4.23767 3.48054 4.34298 3.73485 4.34298 4.00001C4.34298 4.26518 4.23767 4.51949 4.0502 4.70701L1.4057 7.35352Z"
      fill="currentColor"
    />
  </svg>
);
